<div class="orgContainer">

    <mat-card class="menupannel">
      <button mat-icon-button color="accent" (click)="openSettingSidebar = !openSettingSidebar" color="primary">
        <mat-icon>menu</mat-icon>
      </button>
      Settings
    </mat-card>
  
      <!-- Side Bar -->
      <mat-card class="settingsidebar" [ngClass]="{ open: openSettingSidebar }">
        <app-side-navigation></app-side-navigation>
      </mat-card>
      
    <div class="settingsidebarOverlay" (click)="openSettingSidebar = !openSettingSidebar"
    [ngClass]="{ open: openSettingSidebar }"></div>
      <!-- Side Bar -->
    

  
        <div class="inner_wrapper">
  
          <router-outlet></router-outlet>
          <!-- <app-loader></app-loader> -->
        </div>
  
  
  </div>
  